import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import { InventoryRatioFields } from "./HomeTypes";


export interface InventoryPieProps {
  data?: InventoryRatioFields[];
}

export const InventoryPie = (props: InventoryPieProps) => {

  const { data } = props
  const colors = ['#0677FF', '#53D0DA', '#57C4AA'];

  const getOption = () => {
    let pieData = data?.map((item, index) => {
      return { value: item.num, name: item.warehouseName, itemStyle: { color: colors[index] } };
    });

    return {
      title: {
        text: '库存占比',
        left: 20,
        textStyle: {
          fontSize: 21
        }
      },
      tooltip: {
        trigger: 'item'
      },
      legend: {
        top: 'center',
        left: 'right',
        orient: 'vertical'
      },
      series: [
        {
          name: '',
          type: 'pie',
          left: -100,
          radius: '50%',
          label: {
            fontSize: '14px',
            lineHeight: 15,
            formatter: function (v: any) {
              return v.name + '\n' + v.value;
            }
          },
          labelLine: {
            length: 10
          },
          data: pieData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    };
  }

  return (
    <ReactEchartsCore
      echarts={echarts}
      option={getOption() as echarts.EChartOption<echarts.EChartOption.Series>}
      style={{ height: '100%' }}
    />
  )
}